<template>
  <section
    v-if="list && list.length > 0"
    class="video-model"
  >
    <h3>热点视频</h3>
    <ul class="video-model-list">
      <li
        v-for="(item, index) in list"
        v-show="show(index)"
        :key="index"
        data-exposed="false"
        :data-report="JSON.stringify({ hot_video: item.name })"
      >
        <a
          :href="item.link"
          :uigs="'out_home_hot_' + index"
          :data-report="JSON.stringify({ hot_video_click: item.name })"
        >
          <div class="video-model-img-h">
            <img-item :src="item.img_url" />
          </div>
          <div class="video-model-info">
            <p>{{ item.name }}</p>
          </div>
        </a>
      </li>
    </ul>
    <div class="video-model-btn">
      <a
        uigs="home_hot_video_change"
        @click="change"
      ><span class="change">换一换</span></a>
    </div>
  </section>
</template>

<script>
import { throttle } from '@asset/js/util';
import { mapState } from 'vuex';

import { getSsrUigsParams } from '../../common/js/util';
import ImgItem from './ImgItem';

export default {
  components: {
    ImgItem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      num: 6,
      start: 0,
    };
  },
  computed: {
    ...mapState('common', ['$config']),
  },
  mounted() {
    const self = this;
    window.addEventListener('scroll', throttle(self.scrollHandler, 200));
    self.scrollHandler();
  },
  methods: {
    show(index) {
      if (index >= this.start && index < this.start + this.num) {
        return true;
      }
      return false;
    },
    change() {
      const start = this.start + this.num;
      this.start = start >= this.list.length ? 0 : start;
      this.$nextTick(() => {
        this.scrollHandler();
      });
    },
    scrollHandler() {
      const self = this;
      const winH = window.innerHeight;
      const $reportList = document.querySelectorAll('[data-report][data-exposed="false"]');

      if ($reportList.length) {
        // pv日志发送
        const params = getSsrUigsParams();
        const { $config = {} } = self;
        const paramsExd = {
          ...params,
          pbtype: 'pv',
          is_na: $config.isNa,
          is_mix: $config.iskd || 0,
          hitkd: $config.isHitKd,
          qua: $config.qua || '',
          guid: $config.guid,
          pagetype: 'home_promotion',
        };

        [].forEach.call($reportList, (item) => {
          const { top } = item.getBoundingClientRect();
          if (top > 0 && top < winH) {
            item.setAttribute('data-exposed', true);
            let { report } = item.dataset;
            try {
              report = report ? JSON.parse(report) : '';
            } catch (e) {
              report = '';
            }
            report && Object.assign(paramsExd, report);
            self.$uigsKd.send(paramsExd);
          }
        });
      }
    },
  },
};
</script>
